<template>
  <div id="global-uploader">
    <!-- 上传 -->
    <uploader ref="uploader" :auto-start="false" class="uploader-app" :file-status-text="fileStatusText"
      :options="options" @file-complete="fileComplete" @file-error="onFileError" @file-progress="onFileProgress"
      @file-success="onFileSuccess" @files-added="onFilesAdded">
      <uploader-unsupport />
      <uploader-btn id="global-uploader-Folder-btn" ref="uploadFolderBtn" :directory="true" :single="true">
        选择文件夹
      </uploader-btn>
      <uploader-btn id="global-uploader-btn" ref="uploadBtn" :attrs="attrs">
        选择文件
      </uploader-btn>
      <uploader-list v-show="panelShow">
        <div slot-scope="props" class="file-panel">
          <div class="file-title">
            <div class="title">上传列表</div>
            <div class="middle"></div>
            <div class="operate">
              <span class="warning-about-empty-folder">空文件夹不会被上传</span>
              <el-button title="收起" type="text" @click="close">
                <i class="el-icon-minus"></i>
              </el-button>
              <el-button title="关闭" type="text" @click="closeCache">
                <i class="el-icon-close"></i>
              </el-button>
            </div>
          </div>

          <div class="file-list">
            <uploader-files ref="files" :file="props.fileList" :list="true" />
            <div v-if="!props.fileList.length" class="no-file">
              <el-image :src="require('@/assets/images/data_empty.png')" style="width: 300px; height: 200px" />
            </div>
          </div>
        </div>
      </uploader-list>
    </uploader>
  </div>
</template>

<script>
/**
 *   全局上传插件
 *   调用方法：Bus.$emit('openUploader', {}) 打开文件选择框，参数为需要传递的额外参数
 *   监听函数：Bus.$on('fileAdded', fn); 文件选择后的回调
 *            Bus.$on('fileSuccess', fn); 文件上传成功的回调
 */

import Bus from "@/libs/bus";
import Uploader from "vue-simple-uploader";
import SparkMD5 from "spark-md5";
import $ from "jquery";
import { baseURL, tokenName } from "@/config/net.config";
import request from "@/utils/request";

export default {
  name: "GlobalUploader",
  install(Vue) {
    Vue.component("GlobalUploader", this);
  },
  components: {
    Uploader: Uploader.Uploader,
    // UploaderDrop: Uploader.UploaderDrop,
    UploaderBtn: Uploader.UploaderBtn,
    UploaderUnsupport: Uploader.UploaderUnsupport,
    UploaderList: Uploader.UploaderList,
    UploaderFiles: Uploader.UploaderFiles,
    // UploaderFile: Uploader.UploaderFile,
  },
  data() {
    return {
      hideSuccess: false,
      options: {
        target: `${baseURL}/dms/file/upload/chunk`,
        chunkSize: 5 * 1024 * 1024,
        fileParameterName: "file",
        maxChunkRetries: undefined,
        simultaneousUploads: 10,
        testChunks: true, // 是否开启服务器分片校验
        initialPaused: true,
        // 服务器分片校验函数，秒传及断点续传基础
        checkChunkUploadedByResponse(chunk, message) {
          const objMessage = JSON.parse(message);
          if (objMessage.code === 2001) {
            // 1 秒传
            return true;
          }
          // 没传过
          return (objMessage.data || []).indexOf(chunk.offset + 1) >= 0;
        },
        headers: { token: localStorage.getItem(tokenName) },
        query: () => { },
      },
      attrs: {
        accept: "*",
      },
      index: 0,
      busType: "",
      insertFn: null,
      fileList: [],
      panelShow: false, // 选择文件后，展示上传panel
    };
  },
  computed: {
    // Uploader实例
    uploader() {
      return this.$refs.uploader.uploader;
    },
  },
  watch: {},
  mounted() {
    const that = this;
    Bus.$on("openUploader", (query, attrs, type) => {
      this.params = query || {};
      if (this.params.uploadType === 0 && this.$refs.uploadBtn) {
        this.busType = type.busType;
        this.insertFn = type.insertFn;
        if (attrs && attrs.accept) {
          that.attrs.accept = attrs.accept;
          $("#global-uploader-btn :input[type='file']")[0].accept =
            that.attrs.accept;
        } else {
          $("#global-uploader-btn :input[type='file']")[0].accept = "*";
        }
        $("#global-uploader-btn").click();
      } else if (this.params.uploadType === 1 && this.$refs.uploadFolderBtn) {
        $("#global-uploader-Folder-btn").click();
      }
    });
    Bus.$on("openUploadList", () => {
      this.panelShow = !this.panelShow;
    });
  },
  destroyed() {
    Bus.$off("openUploader");
  },
  methods: {
    onFilesAdded(files) {
      const limitation = 300;
      if (files.length > limitation) {
        this.$alert(`文件过多，单次最多可上传${limitation}个文件`, {
          confirmButtonText: "确定",
          callback: () => {
            this.clearFile(files);
          },
        });
        return false;
      }
      this.panelShow = true;
      files.forEach((item) => {
        this.do_preCheck(item);
      });
    },
    clearFile(files) {
      files.forEach((file) => {
        file.cancel();
      });
    },
    onFileProgress(rootFile, file, chunk) {
      // eslint-disable-next-line no-console
      console.log(
        `上传中 ${file.name}，chunk：${chunk.startByte / 1024 / 1024} ~ ${chunk.endByte / 1024 / 1024
        }`
      );
    },
    fileStatusText(status, response) {
      const statusTextMap = {
        uploading: "上传中...",
        paused: "等待中...",
        waiting: "等待中...",
      };
      if (status === "success") {
        return response.message;
      }
      if (status === "error") {
        return `上传失败:${response.message}`;
      }
      return statusTextMap[status];
    },
    onFileSuccess(rootFile, file, response) {
      const that = this;
      const res = JSON.parse(response);
      // 服务器自定义的错误（即虽返回200，但是是错误的情况），这种错误是Uploader无法拦截的
      if (
        res.code === 2006 ||
        res.code === 2004 ||
        res.code === 500 ||
        res.code === -1
      ) {
        file.error = true;
        that.fileStatusText("error", res);
        that.$notify.error({
          title: "错误",
          message: res.message,
        });
        return;
      }
      request({
        method: "post",
        url: "/dms/file/upload/merge",
        data: {
          filename: file.name,
          identifier: file.uniqueIdentifier,
          key: this.params.key,
          parent: this.params.parent,
          relativePath: file.relativePath,
          totalSize: file.size,
          type: this.params.type,
        },
      })
        .then((res1) => {
          // busType 0 为全局 1为局部页面 2为全局的头像 传递不同事件
          if (res1.code === 1) {
            if (that.params.type === 4 && this.busType === 1) {
              Bus.$emit("fileListSuccess", res1.data);
            } else if (that.params.type === 4 && this.busType === 0) {
              Bus.$emit("fileAllSuccess", res1.data);
            } else if (that.params.type === 4 && this.busType === 2) {
              Bus.$emit("filePhotoSuccess", res1.data);
            } else if (that.params.type === 4 && this.busType === 3) {
              Bus.$emit("fileSingleSuccess", res1.data, this.insertFn);
            }
          } else {
            file.error = true;
            that.fileStatusText("error", { message: res1.data });
          }
        })
        .catch((err) => {
          file.error = true;
          that.fileStatusText("error", { message: err.message });
          return false;
        });
    },
    fileComplete() {
      const that = this;
      const uploaderInstance = this.$refs.uploader.uploader;
      if (uploaderInstance.getSize() === uploaderInstance.sizeUploaded()) {
        if (that.params.type === 0) {
          Bus.$emit("fileSuccess");
        } else if (that.params.type === 2) {
          Bus.$emit("fileGroupSuccess");
        } else if (that.params.type === 1) {
          Bus.$emit("fileOrgSuccess");
        }
      }
    },
    onFileError(rootFile, file, response) {
      this.fileStatusText("error", response);
      this.$notify.error({
        title: "错误",
        message: response.message,
      });
    },
    do_preCheck(files) {
      let suffix = "";
      const arr = files.name.split(".");
      if (arr.length >= 1) {
        suffix = `.${arr[arr.length - 1]}`;
      }
      request({
        url: "/dms/file/upload/check",
        method: "post",
        data: {
          key: this.params.key,
          parent: this.params.parent,
          type: this.params.type,
          size: files.size,
          suffix,
          relativePath: files.relativePath,
        },
      })
        .then((res) => {
          if (res.code === 1) {
            $(".uploader-file-meta")
              .eq(this.index)
              .css("width", "12%")
              .css("color", "#1890ff")
              .text(this.params.router);
            $(".uploader-file-name").css("width", "41%");
            this.index += 1;
            this.computeMD5(files);
          }
        })
        .catch(() => {
          files.cancel();
        });
    },
    /**
     * 计算md5，实现断点续传及秒传
     * @param file
     */
    computeMD5(file) {
      const fileReader = new FileReader();
      const time = new Date().getTime();
      const blobSlice =
        File.prototype.slice ||
        File.prototype.mozSlice ||
        File.prototype.webkitSlice;
      let currentChunk = 0;
      const chunkSize = 10 * 1024 * 1000;
      const chunks = Math.ceil(file.size / chunkSize);
      const spark = new SparkMD5.ArrayBuffer();
      // file.cmd5 = true
      file.pause();

      loadNext();

      fileReader.onload = (e) => {
        spark.append(e.target.result);

        if (currentChunk < chunks) {
          currentChunk++;
          loadNext();

          // 实时展示MD5的计算进度
          this.$nextTick(() => {
            $(`.myStatus_${file.id}`).text(
              `校验MD5 ${((currentChunk / chunks) * 100).toFixed(0)}%`
            );
          });
        } else {
          const md5 = spark.end();
          // spark.destroy()
          this.computeMD5Success(md5, file);
          // eslint-disable-next-line no-console
          console.log(
            `MD5计算完毕：${file.name} \nMD5：${md5} \n分片：${chunks} 大小:${file.size
            } 用时：${new Date().getTime() - time} ms`
          );
        }
      };

      fileReader.onerror = function () {
        this.error(`文件${file.name}读取出错，请检查该文件`);
        file.cancel();
      };

      function loadNext() {
        const start = currentChunk * chunkSize;
        const end =
          start + chunkSize >= file.size ? file.size : start + chunkSize;

        fileReader.readAsArrayBuffer(blobSlice.call(file.file, start, end));
      }
    },

    computeMD5Success(md5, file) {
      // 将自定义参数直接加载uploader实例的opts上
      Object.assign(this.uploader.opts, {
        query: {
          ...this.params,
        },
      });
      file.uniqueIdentifier = md5;
      // file.cmd5 = false
      file.resume();
    },
    close() {
      this.panelShow = false;
    },
    closeCache() {
      this.uploader.cancel();
      this.index = 0;
      this.panelShow = false;
    },
    error(msg) {
      this.$notify({
        title: "错误",
        message: msg,
        type: "error",
        duration: 2000,
      });
    },
  },
};
</script>

<style scoped lang="scss">
#global-uploader {
  position: fixed;
  z-index: 9999;
  right: 90px;
  bottom: 20px;
  -webkit-box-shadow: 1px 1px 8px #cecece;
  box-shadow: 1px 1px 8px #b7b7b7;
  background: #ffffff;
  border-radius: 3px;

  .uploader-app {
    width: 700px;
  }

  #uploadDrop {
    display: none;
    position: fixed;
    z-index: 99999;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    background: rgba(255, 255, 255, 0.8);
    border: 10px dashed #ccc;
    color: #aaa;
    font-size: 60px;
    text-align: center;
  }

  .file-panel {
    background-color: #fff;
    border: 1px solid #e2e2e2;
    border-radius: 7px 7px 0 0;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);

    .file-title {
      display: flex;
      height: 40px;
      line-height: 40px;
      padding: 0 15px;
      border-bottom: 1px solid #ddd;

      .title {
        font-size: 20px;
        font-weight: 600;
      }

      .middle {
        .hide-success-box {
          margin-left: 20px;
        }
      }

      .operate {
        flex: 1;
        text-align: right;

        .warning-about-empty-folder {
          background: yellow;
          color: red;
          font-size: 14px;
          padding: 5px 10px 5px 6px;
          margin-right: 20px;
        }
      }
    }

    .file-list {
      position: relative;
      height: 350px;
      overflow-x: hidden;
      overflow-y: auto;
      background-color: #fff;
      padding: 5px 5px 5px 5px;
      margin: 0;

      ::v-deep {
        .uploader-file-status {
          text-align: center;
          text-indent: 0;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
      }
    }
  }

  .no-file {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 16px;
  }

  ::v-deep {
    .uploader-file-icon {}
  }

  ::v-deep {
    .uploader-file-actions>span {
      margin-right: 6px;
    }
  }
}

/* 隐藏上传按钮 */
#global-uploader-btn {
  position: absolute;
  clip: rect(0, 0, 0, 0);
}

#global-uploader-Folder-btn {
  position: absolute;
  clip: rect(0, 0, 0, 0);
}
</style>
